import { retrieveReportsMatterStatusCount } from "@/lib/data/requests";
import { queryKeys } from "@/lib/data/static";

export const retrieveReportsMatterStatusCountQueryOptions = (
  matterStatusCategories: string[],
  classification: { incidentTypeIds?: string[]; claimTypeIds?: string[] } = {},
) => {
  return {
    queryKey: [
      queryKeys.reports,
      "matter-status-count",
      matterStatusCategories,
      classification,
    ],
    enabled: matterStatusCategories.length > 0,
    queryFn: () =>
      retrieveReportsMatterStatusCount({
        category: matterStatusCategories,
        ...classification,
      }),
  };
};
